import { render, staticRenderFns } from "./JournalTeacherVisits.vue?vue&type=template&id=73bc3364&scoped=true&"
import script from "./JournalTeacherVisits.vue?vue&type=script&lang=js&"
export * from "./JournalTeacherVisits.vue?vue&type=script&lang=js&"
import style0 from "./JournalTeacherVisits.vue?vue&type=style&index=0&id=73bc3364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc3364",
  null
  
)

export default component.exports